import React, { createContext, useContext } from 'react';

const isDossierValidationPath: boolean = false;
const setDossierValidationPath: React.Dispatch<React.SetStateAction<boolean>> = () => {};

const onExit: () => void = () => {};
const setOnExit: React.Dispatch<React.SetStateAction<() => void>> = () => {};

const headerTitle: string = 'Vérifier les informations du dossier';
const setHeaderTitle: React.Dispatch<React.SetStateAction<string>> = () => {};

const headerButton: string = 'Enregister et quitter';
const setHeaderButton: React.Dispatch<React.SetStateAction<string>> = () => {};

const pathOnExit: string | null = null;
const setPathOnExit: React.Dispatch<React.SetStateAction<string | null>> = () => {};

const actionsBloc: React.ReactNode = null;
const setActionsBloc: React.Dispatch<React.SetStateAction<React.ReactNode>> = () => {};

const DossierValidationHeaderContext = createContext({
    isDossierValidationPath,
    setDossierValidationPath,
    onExit,
    setOnExit,
    headerTitle,
    setHeaderTitle,
    headerButton,
    setHeaderButton,
    pathOnExit,
    setPathOnExit,
    actionsBloc,
    setActionsBloc,
});

export const useDossierValidationHeader = () => useContext(DossierValidationHeaderContext);

export default DossierValidationHeaderContext;
